class BranchesTagify {
    constructor(inputElm, branches) {
        const onSelectSuggestion = (e) => {
            if( e.detail.event.target.matches('.remove-all-tags')) {
                tagify.removeAllTags()
            }
            // custom class from "dropdownHeaderTemplate"
            else if( e.detail.event.target.matches('.add-all-tags') ) {
                let selectedItems = tagify.dropdown.getAllSuggestionsRefs();
                let tagsToAdd = [];
                for (let i in selectedItems){
                    if(selectedItems[i].attributes.uuid){
                        let obj = branches.find(o => o.value === selectedItems[i].attributes.value.value);
                        tagsToAdd.push(obj);
                    }
                }
                tagify.addTags(tagsToAdd, true, true);
                tagify.dropdown.hide();
            }
        }

        const tagify = new Tagify(inputElm, {
            tagTextProp: 'name', // very important since a custom template is used with this property as text
            enforceWhitelist: true,
            skipInvalid: true, // do not remporarily add invalid tags
            edit: false,
            dropdown: {
                classname: "cy-branches-dropdown",
                closeOnSelect: false,
                enabled: 0,
                maxItems: 500,
                searchKeys: ['name', 'subnet']  // very important to set by which keys to search for suggesttions when typing
            },
            templates: {
                tag: this.tagTemplate,
                dropdownItem: this.suggestionItemTemplate,
                dropdownHeader: this.dropdownHeaderTemplate,
                dropdownItemNoMatch: tagData =>
                    `<div class='${tagify.settings.classNames.dropdownItem} text-primary' value="noMatch" tabindex="0" role="option">
                        No Branches found for: <strong>${tagData.value}</strong>
                    </div>`
            },
            whitelist: branches,
        }).on('dropdown:select', onSelectSuggestion);
        return tagify;
    }
    tagTemplate(tagData){
        const getBranchTagHtml = (tagData) => {
            let icon = '<img src="/media/goodaccess/icons/branch/'+tagData['icon_id']+'.svg" alt="icon" class="h-25px">';
            if(tagData.value === 'all'){
                icon = 'All';
            }

            return '<div class="d-flex align-items-center p-0">' +
                '       <div class="symbol symbol-25px me-2 border ga-border-primary-300 symbol-circle rounded-circle">' +
                '           <div class="symbol-label bg-light-primary border border-2 border-white text-primary fs-7 overflow-hidden">' + icon +'</div>' +
                ((tagData.value !== 'all') ?
                    (!tagData['is_connected'] ?
                        '<span class="symbol-badge badge badge-circle bg-danger start-75 top-75 w-10px h-10px fs-10 text-center text-white">&#10005;</span>'
                        : '<span class="symbol-badge badge badge-circle bg-success start-75 top-75 w-10px h-10px fs-10 text-center text-white">\t\n' + '&#10003;</span>')
                : '') +
                '       </div>' +
                '       <div class="d-flex justify-content-start flex-column me-2 rounded-0">' +
                '           <div><span class="fw-bold text-primary mb-1 fs-7">'+tagData['name']+'</span></div>' +
                '           <span class="fw-semibold d-block fs-8 ga-text-primary-800"></span>' +
                '       </div>' +
                '   </div>';
        }

        return `<tag title="${tagData.name}"
                        contenteditable='false'
                        spellcheck='false'
                        tabIndex="-1"
                        class="tagify__tag p-1 ${tagData.class ? tagData.class : ""}"
                        ${this.getAttributes(tagData)}>
                    <x title='' class='tagify__tag__removeBtn' role='button' aria-label='remove tag'></x>
                    ${getBranchTagHtml(tagData)}
                </tag>`;
    }

    suggestionItemTemplate(tagData){
        const getBranchHtml = (tagData) => {
            let icon = '<img src="/media/goodaccess/icons/branch/'+tagData['icon_id']+'.svg" alt="icon" class="min-w-35px">';
            if(tagData.value === 'all'){
                icon = 'All';
            }

            return '<div class="d-flex align-items-center p-0" data-cy="ac-add-branch">' +
                '       <div class="symbol symbol-35px me-2 border ga-border-primary-300 symbol-circle rounded-circle">' +
                '           <div class="symbol-label bg-light-primary border border-2 border-white text-primary">' +
                                icon +
                '           </div>' +
                ((tagData.value !== 'all') ?
                    (!tagData['is_connected'] ?
                        '<span class="symbol-badge badge badge-circle bg-danger start-75 top-75 w-10px h-10px fs-10 text-center text-white">&#10005;</span>'
                        : '<span class="symbol-badge badge badge-circle bg-success start-75 top-75 w-10px h-10px fs-10 text-center text-white">\t\n' + '&#10003;</span>')
                    : '') +
                '       </div>' +
                '       <div class="d-flex justify-content-start flex-column me-2 rounded-0">' +
                '           <div><span class="fw-bold text-primary mb-1 fs-7">'+tagData['name']+'</span></div>' +
                '           <span class="fw-semibold d-block fs-8 ga-text-primary-800">'+tagData['subnet']+'</span>' +
                '       </div>' +
                '   </div>';
        }

        return `<div ${this.getAttributes(tagData)}
                    class='tagify__dropdown__item ${tagData.class ? tagData.class : ""}'
                    tabindex="0"
                    role="option">
                    ${getBranchHtml(tagData)}
                </div>`;
    }

    dropdownHeaderTemplate(suggestions){
        const containsAll = suggestions.some(item => item.value === 'all');

        return `<header data-selector='tagify-suggestions-header' class="${this.settings.classNames.dropdownItem}">
                    <div class="d-flex justify-content-between text-primary">
                        `+(!containsAll ? '<strong class="text-decoration-underline-ga primary add-all-tags">Add All</strong>' : '<span></span>')+`
                        ${this.value.length ? `<a class='remove-all-tags text-decoration-underline-ga danger text-danger'>Remove all</a>` : ''}
                    </div>
                    `+(!containsAll ? `<span class="text-primary">${suggestions.length} Branches</span>` : '')+`
                </header>`;
    }
}
window.BranchesTagify = BranchesTagify;